const API_API_STORE = 'unified-mapping-dev-menu-api-url';
const API_INDEX_STORE = 'unified-mapping-dev-menu-api-index';
const MENU_TOGGLE_STORE = 'unified-mapping-dev-menu-api-toggle';

const MENU_SELECTOR = '.unified-mapping-dev-menu.menu';
const EXPAND_SELECTOR = '.unified-mapping-dev-menu.expand';

const getMenuAPIStore = () => window.localStorage.getItem(API_API_STORE) || 'prod';
const getMenuIndexStore = () => window.localStorage.getItem(API_INDEX_STORE) || 'seniors';
const getMenuToggleStore = () => window.localStorage.getItem(MENU_TOGGLE_STORE);
const setMenuToggleStore = (v) => window.localStorage.setItem(MENU_TOGGLE_STORE, v);

const setHighlightCombined = () =>
  (getMenuIndexStore() === 'combined-dev' && window.localStorage.setItem(API_API_STORE, 'dev')) ||
  (getMenuIndexStore() === 'combined-stg' && window.localStorage.setItem(API_API_STORE, 'stg'));

const checkMenuValue = (v) => getMenuAPIStore() === v || getMenuIndexStore() === v;

const createMenuButton = (i, v, text) => {
  const el = document.createElement('button');
  el.innerText = text;
  el.style.border = checkMenuValue(v) ? '2px solid #4285F4' : '2px solid grey';
  el.onclick = () => (window.localStorage.setItem(i, v), window.location.reload());
  return el;
};

const setupDevMenu = () => {
  document.querySelector('html').classList.remove('hidden');
  setHighlightCombined();
  const menu = document.querySelector(MENU_SELECTOR);
  const expand = document.querySelector(EXPAND_SELECTOR);
  menu.style.display = 'flex';
  menu.innerText = 'Dev Menu';
  menu.style.transform =
    getMenuToggleStore() === 'open' ? 'translate(0, 0)' : 'translate(-100%, 0)';
  expand.onclick = () => ((menu.style.transform = 'translate(0, 0)'), setMenuToggleStore('open'));
  expand.style.display = 'block';
  const closeButton = document.createElement('button');
  closeButton.innerText = 'X';
  closeButton.onclick = () => (
    setMenuToggleStore('close'), (menu.style.transform = 'translate(-100%, 0)')
  );
  const prodButton = createMenuButton(API_API_STORE, 'prod', 'prod api');
  const stgButton = createMenuButton(API_API_STORE, 'stg', 'stg api');
  const devButton = createMenuButton(API_API_STORE, 'dev', 'dev api');
  const seniorsCardButton = createMenuButton(API_INDEX_STORE, 'seniors', 'seniors index');
  const seniorsButton = createMenuButton(API_INDEX_STORE, 'seniorscard', 'seniorscard index');
  const activeKidsButton = createMenuButton(API_INDEX_STORE, 'activekids', 'activekids index');
  const combDevButton = createMenuButton(API_INDEX_STORE, 'combined-dev', 'dev combine seniors');
  const combStgButton = createMenuButton(API_INDEX_STORE, 'combined-stg', 'stg combine seniors');
  menu.append(closeButton);
  closeButton.style.marginBottom = '2em';
  menu.append(prodButton);
  menu.append(stgButton);
  menu.append(devButton);
  devButton.style.marginBottom = '2em';
  menu.append(seniorsCardButton);
  menu.append(seniorsButton);
  menu.append(activeKidsButton);
  activeKidsButton.style.marginBottom = '1em';
  menu.append(combDevButton);
  menu.append(combStgButton);
  document.body.append(menu);
  return true;
};

const envIsDev =
  window.location.hostname === 'dev.maps-dev.testservicensw.net' ||
  window.location.hostname === 'localhost';

const maybeSetupDevMenu = () => (envIsDev && setupDevMenu()) || false;

export { maybeSetupDevMenu, getMenuAPIStore, getMenuIndexStore };
